export var CustomerPortalWidgetType = /*#__PURE__*/ function(CustomerPortalWidgetType) {
    CustomerPortalWidgetType["HeroSection"] = "HERO_SECTION";
    CustomerPortalWidgetType["ProjectPlan"] = "PROJECT_PLAN";
    CustomerPortalWidgetType["SPACE"] = "SPACE";
    CustomerPortalWidgetType["AllFiles"] = "ALL_FILES";
    CustomerPortalWidgetType["FORMS"] = "FORMS";
    CustomerPortalWidgetType["ProjectUpdates"] = "PROJECT_UPDATES";
    CustomerPortalWidgetType["AccountFiles"] = "ACCOUNT_FILES";
    CustomerPortalWidgetType["AccountSpaces"] = "ACCOUNT_SPACES";
    CustomerPortalWidgetType["CHATS"] = "CHATS";
    CustomerPortalWidgetType["FAQ"] = "FAQ";
    CustomerPortalWidgetType["Metrics"] = "METRICS";
    CustomerPortalWidgetType["Feature"] = "FEATURE";
    CustomerPortalWidgetType["ImageGallery"] = "IMAGE_GALLERY";
    CustomerPortalWidgetType["Resources"] = "RESOURCES";
    CustomerPortalWidgetType["ProjectSummaryInformation"] = "PROJECT_SUMMARY_INFORMATION";
    CustomerPortalWidgetType["AccountSummaryInformation"] = "ACCOUNT_SUMMARY_INFORMATION";
    CustomerPortalWidgetType["AccountProjectsList"] = "ACCOUNT_PROJECTS_LIST";
    CustomerPortalWidgetType["ProjectForms"] = "PROJECT_FORMS";
    CustomerPortalWidgetType["ProjectHours"] = "PROJECT_HOURS";
    CustomerPortalWidgetType["ProjectOverview"] = "PROJECT_OVERVIEW";
    CustomerPortalWidgetType["TeamMembers"] = "TEAM_MEMBERS";
    CustomerPortalWidgetType["LogoWidget"] = "LOGO_WIDGET";
    CustomerPortalWidgetType["VideoList"] = "VIDEO_LIST";
    CustomerPortalWidgetType["CTA"] = "CTA";
    CustomerPortalWidgetType["Footer"] = "FOOTER";
    CustomerPortalWidgetType["ProjectTasksList"] = "PROJECT_TASKS_LIST";
    CustomerPortalWidgetType["Spotlight"] = "SPOTLIGHT";
    CustomerPortalWidgetType["IFrame"] = "IFRAME";
    CustomerPortalWidgetType["ProjectTimeTracking"] = "PROJECT_TIME_TRACKING";
    CustomerPortalWidgetType["AccountTimeTracking"] = "ACCOUNT_TIME_TRACKING";
    CustomerPortalWidgetType["ProjectInvoicing"] = "PROJECT_INVOICES_LIST";
    CustomerPortalWidgetType["AccountInvoicing"] = "ACCOUNT_INVOICES_LIST";
    CustomerPortalWidgetType["MarketplaceAppWidget"] = "MARKETPLACE_APP_WIDGET";
    CustomerPortalWidgetType["LdsWidget"] = "LDS_WIDGET";
    CustomerPortalWidgetType["Sheets"] = "SHEETS";
    return CustomerPortalWidgetType;
}({});
export var CustomerPortalPageType = /*#__PURE__*/ function(CustomerPortalPageType) {
    CustomerPortalPageType["Home"] = "HOME";
    CustomerPortalPageType["Chat"] = "CHAT";
    CustomerPortalPageType["AccountOverview"] = "ACCOUNT_OVERVIEW";
    CustomerPortalPageType["Custom"] = "CUSTOM";
    return CustomerPortalPageType;
}({});
export var CpWidgetVariantType = /*#__PURE__*/ function(CpWidgetVariantType) {
    CpWidgetVariantType["Default"] = "DEFAULT";
    CpWidgetVariantType["HeroSectionFullBackground"] = "HERO_SECTION_FULL_BACKGROUND";
    CpWidgetVariantType["HeroSectionWithImageAtBottom"] = "HERO_SECTION_WITH_IMAGE_AT_BOTTOM";
    CpWidgetVariantType["HeroSectionWithImageAtCenter"] = "HERO_SECTION_WITH_IMAGE_AT_CENTER";
    // FAQ
    CpWidgetVariantType["FAQAccordion"] = "FAQ_ACCORDION";
    CpWidgetVariantType["FAQGrid"] = "FAQ_GRID";
    CpWidgetVariantType["FAQRow"] = "FAQ_ROW";
    // Image Gallery
    CpWidgetVariantType["ImageGalleryGrid"] = "IMAGE_GALLERY_GRID";
    CpWidgetVariantType["ImageGalleryCarousel"] = "IMAGE_GALLERY_CAROUSEL";
    CpWidgetVariantType["ImageGalleryRowCarousel"] = "IMAGE_GALLERY_ROW_CAROUSEL";
    // Metrics
    CpWidgetVariantType["MetricsGrid"] = "METRICS_GRID";
    CpWidgetVariantType["MetricsCardGrid"] = "METRICS_CARD_GRID";
    CpWidgetVariantType["MetricsRightSidedGrid"] = "METRICS_RIGHT_SIDED_GRID";
    // Video List
    CpWidgetVariantType["SingleVideo"] = "SINGLE_VIDEO";
    CpWidgetVariantType["VideoListGrid"] = "VIDEO_LIST_GRID";
    CpWidgetVariantType["VerticalVideoStack"] = "VERTICAL_VIDEO_STACK";
    CpWidgetVariantType["ScrollableSideMenu"] = "SCROLLABLE_SIDE_MENU";
    // Resources
    CpWidgetVariantType["ResourcesGrid"] = "RESOURCES_GRID";
    CpWidgetVariantType["ResourcesScrollableGrid"] = "RESOURCES_SCROLLABLE_GRID";
    CpWidgetVariantType["ResourcesList"] = "RESOURCES_LIST";
    // CTA
    CpWidgetVariantType["CTALeftAligned"] = "CTA_LEFT_ALIGNED";
    CpWidgetVariantType["CTACenterAligned"] = "CTA_CENTER_ALIGNED";
    CpWidgetVariantType["CTAStretched"] = "CTA_STRETCHED";
    CpWidgetVariantType["CTAStretchedWithBackground"] = "CTA_STRETCHED_WITH_BACKGROUND";
    CpWidgetVariantType["CTATitleAndContentSection"] = "CTA_TITLE_AND_CONTENT_SECTION";
    // Feature
    CpWidgetVariantType["FeatureWithImageOnLeft"] = "FEATURE_WITH_IMAGE_ON_LEFT";
    CpWidgetVariantType["FeatureWithImageOnRight"] = "FEATURE_WITH_IMAGE_ON_RIGHT";
    // Footer
    CpWidgetVariantType["FooterWithoutLinkGroups"] = "FOOTER_WITHOUT_LINK_GROUPS";
    CpWidgetVariantType["FooterWithLinkGroupOnBottom"] = "FOOTER_WITH_LINK_GROUP_ON_BOTTOM";
    // Project Forms
    // SingleFormWithImageAtTheLeft = 'SINGLE_FORM_WITH_IMAGE_AT_THE_LEFT',
    // SingleFormWithImageAtTheRight = 'SINGLE_FORM_WITH_IMAGE_AT_THE_RIGHT',
    // SingleFormWithImageAtTheCenter = 'SINGLE_FORM_WITH_IMAGE_AT_THE_CENTER',
    // MultiFormWithAllRoundBorder = 'MULTI_FORM_WITH_ALL_ROUND_BORDER',
    CpWidgetVariantType["MultiFormWithImageAtTheLeft"] = "MULTI_FORM_WITH_IMAGE_AT_THE_LEFT";
    CpWidgetVariantType["MultiFormWithBottomBorder"] = "MULTI_FORM_WITH_BOTTOM_BORDER";
    // Team Members
    CpWidgetVariantType["TeamMemberList"] = "TEAM_MEMBER_LIST";
    CpWidgetVariantType["TeamMemberCard"] = "TEAM_MEMBER_CARD";
    // Logo
    CpWidgetVariantType["LogoWithHeader"] = "LOGO_WITH_HEADER";
    CpWidgetVariantType["LogoWithoutHeader"] = "LOGO_WITHOUT_HEADER";
    // Iframe
    CpWidgetVariantType["IFrameHeroSection"] = "IFRAME_HERO_SECTION";
    CpWidgetVariantType["IFrameVideos"] = "IFRAME_VIDEOS";
    CpWidgetVariantType["IFrameImageGallery"] = "IFRAME_IMAGE_GALLERY";
    CpWidgetVariantType["IFrameFeatures"] = "IFRAME_FEATURES";
    // Project Plan
    CpWidgetVariantType["ProjectPlanGanttView"] = "PROJECT_PLAN_GANTT_VIEW";
    CpWidgetVariantType["ProjectPlanBoardView"] = "PROJECT_PLAN_BOARD_VIEW";
    // Summary Information
    CpWidgetVariantType["SummaryInformationCardList"] = "SUMMARY_INFORMATION_CARD_LIST";
    CpWidgetVariantType["SummaryInformationRowList"] = "SUMMARY_INFORMATION_ROW_LIST";
    return CpWidgetVariantType;
}({});
const widgetsWithVariants = [
    "HERO_SECTION",
    "FAQ",
    "IMAGE_GALLERY",
    "METRICS",
    "VIDEO_LIST",
    "RESOURCES",
    "CTA",
    "FEATURE",
    "FOOTER",
    "PROJECT_FORMS",
    "TEAM_MEMBERS",
    "LOGO_WIDGET",
    "IFRAME",
    "PROJECT_PLAN",
    "PROJECT_SUMMARY_INFORMATION",
    "ACCOUNT_SUMMARY_INFORMATION"
];
export const doesWidgetHaveVariants = (widgetType)=>widgetsWithVariants.includes(widgetType);
export const WidgetToVariantMap = {
    ["HERO_SECTION"]: [
        "HERO_SECTION_FULL_BACKGROUND",
        "HERO_SECTION_WITH_IMAGE_AT_BOTTOM",
        "HERO_SECTION_WITH_IMAGE_AT_CENTER"
    ],
    ["FAQ"]: [
        "FAQ_ACCORDION",
        "FAQ_GRID",
        "FAQ_ROW"
    ],
    ["IMAGE_GALLERY"]: [
        "IMAGE_GALLERY_GRID",
        "IMAGE_GALLERY_ROW_CAROUSEL",
        "IMAGE_GALLERY_CAROUSEL"
    ],
    ["METRICS"]: [
        "METRICS_GRID",
        "METRICS_CARD_GRID",
        "METRICS_RIGHT_SIDED_GRID"
    ],
    ["VIDEO_LIST"]: [
        "SINGLE_VIDEO",
        "VIDEO_LIST_GRID",
        "VERTICAL_VIDEO_STACK",
        "SCROLLABLE_SIDE_MENU"
    ],
    ["RESOURCES"]: [
        "RESOURCES_GRID",
        "RESOURCES_SCROLLABLE_GRID",
        "RESOURCES_LIST"
    ],
    ["CTA"]: [
        "CTA_LEFT_ALIGNED",
        "CTA_CENTER_ALIGNED",
        "CTA_STRETCHED",
        "CTA_STRETCHED_WITH_BACKGROUND",
        "CTA_TITLE_AND_CONTENT_SECTION"
    ],
    ["FEATURE"]: [
        "FEATURE_WITH_IMAGE_ON_LEFT",
        "FEATURE_WITH_IMAGE_ON_RIGHT"
    ],
    ["FOOTER"]: [
        "FOOTER_WITHOUT_LINK_GROUPS",
        "FOOTER_WITH_LINK_GROUP_ON_BOTTOM"
    ],
    ["TEAM_MEMBERS"]: [
        "TEAM_MEMBER_LIST",
        "TEAM_MEMBER_CARD"
    ],
    ["LOGO_WIDGET"]: [
        "LOGO_WITH_HEADER",
        "LOGO_WITHOUT_HEADER"
    ],
    ["PROJECT_PLAN"]: [
        "DEFAULT",
        "PROJECT_PLAN_BOARD_VIEW",
        "PROJECT_PLAN_GANTT_VIEW"
    ],
    ["CHATS"]: undefined,
    ["SPACE"]: undefined,
    ["FORMS"]: undefined,
    ["PROJECT_SUMMARY_INFORMATION"]: [
        "DEFAULT",
        "SUMMARY_INFORMATION_CARD_LIST",
        "SUMMARY_INFORMATION_ROW_LIST"
    ],
    ["ACCOUNT_SUMMARY_INFORMATION"]: [
        "DEFAULT",
        "SUMMARY_INFORMATION_CARD_LIST",
        "SUMMARY_INFORMATION_ROW_LIST"
    ],
    ["ALL_FILES"]: undefined,
    ["ACCOUNT_FILES"]: undefined,
    ["PROJECT_UPDATES"]: undefined,
    ["ACCOUNT_SPACES"]: undefined,
    ["ACCOUNT_PROJECTS_LIST"]: undefined,
    ["PROJECT_HOURS"]: undefined,
    ["PROJECT_OVERVIEW"]: undefined,
    ["PROJECT_TASKS_LIST"]: undefined,
    ["SPOTLIGHT"]: undefined,
    ["PROJECT_TIME_TRACKING"]: undefined,
    ["ACCOUNT_TIME_TRACKING"]: undefined,
    ["PROJECT_INVOICES_LIST"]: undefined,
    ["ACCOUNT_INVOICES_LIST"]: undefined,
    ["MARKETPLACE_APP_WIDGET"]: undefined,
    ["LDS_WIDGET"]: undefined,
    ["PROJECT_FORMS"]: [
        "MULTI_FORM_WITH_IMAGE_AT_THE_LEFT",
        "MULTI_FORM_WITH_BOTTOM_BORDER"
    ],
    ["IFRAME"]: [
        "IFRAME_HERO_SECTION",
        "IFRAME_VIDEOS",
        "IFRAME_IMAGE_GALLERY",
        "IFRAME_FEATURES"
    ],
    ["SHEETS"]: undefined
};
export var CPWidgetRenderAs = /*#__PURE__*/ function(CPWidgetRenderAs) {
    CPWidgetRenderAs["Default"] = "DEFAULT";
    CPWidgetRenderAs["Radio"] = "RADIO";
    CPWidgetRenderAs["MultiLineText"] = "MULTI_LINE_TEXT";
    CPWidgetRenderAs["ExtendableObjectsTabs"] = "EXTENDABLE_OBJECTS_TABS";
    CPWidgetRenderAs["ExtendableObjectsList"] = "EXTENDABLE_OBJECTS_LIST";
    CPWidgetRenderAs["SimpleSearchFilter"] = "SIMPLE_SEARCH_FILTER";
    CPWidgetRenderAs["Image"] = "IMAGE";
    CPWidgetRenderAs["MultiSelect"] = "MULTI_SELECT";
    CPWidgetRenderAs["CollaborationIconConfig"] = "COLLABORATION_ICON_CONFIG";
    CPWidgetRenderAs["EmbedCode"] = "EMBED_CODE";
    CPWidgetRenderAs["Tabs"] = "TABS";
    CPWidgetRenderAs["Checkbox"] = "CHECKBOX";
    CPWidgetRenderAs["Toggle"] = "TOGGLE";
    CPWidgetRenderAs["SimpleList"] = "SIMPLE_LIST";
    CPWidgetRenderAs["GroupedCheckbox"] = "GROUPED_CHECKBOX";
    return CPWidgetRenderAs;
}({});
export var CPWidgetRenderParams = /*#__PURE__*/ function(CPWidgetRenderParams) {
    CPWidgetRenderParams["HttpLink"] = "HTTP_LINK";
    CPWidgetRenderParams["AllowSmartfills"] = "ALLOW_SMART_FILLS";
    return CPWidgetRenderParams;
}({});
export const LIVE_CP_PROJECT_ID = 'live-cp-project-id';
